import React from "react";
import {
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { PhoneInTalk } from "@mui/icons-material";

import { ContactForm } from "src/widgets/ContactForm";
import { ContactInfo } from "src/widgets/ContactInfo";
import { RoutePaths } from "src/app/model";
import { handleBookCall } from "src/shared/utils";

export const ContactsPage: React.FC = () => {
  const theme = useTheme();

  const isMedium = useMediaQuery(theme.breakpoints.down("lg"));
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Stack
      id={RoutePaths.CONTACTS}
      width={1}
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={4}
      sx={{
        scrollMarginTop: 80,
      }}
    >
      <Typography
        color="text.secondary"
        variant="h5"
        fontWeight="light"
        textTransform="uppercase"
        sx={{
          fontSize: { sm: "1.5rem", xs: "1rem" },
        }}
      >
        CONTACT
      </Typography>
      <Stack
        width={1}
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        gap={8}
        sx={{
          flexDirection: { md: "row", xs: "column" },
        }}
      >
        <ContactForm />

        <Stack
          width={1}
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{
            alignItems: { md: "flex-start", xs: "center" },
          }}
          gap={2}
        >
          <Typography
            color="primary"
            variant="h4"
            fontWeight={300}
            sx={{
              textAlign: { md: "start", xs: "center" },

              fontSize: {
                lg: "2.125rem",
                xs: "2rem",
              },
            }}
          >
            Schedule Your AI Strategy Assessment
          </Typography>

          <Typography
            color="text.primary"
            variant="body1"
            textAlign="start"
            sx={{
              textAlign: { md: "start", xs: "center" },
            }}
          >
            If you are facing a high-stakes AI problem and need a partner who
            combines elite expertise with speed and collaboration, let's
            connect. We can help you de-risk your project, empower your team,
            and deliver the breakthrough you need.
          </Typography>

          <ContactInfo />

          <Button
            variant="outlined"
            color="primary"
            size={isMedium ? "medium" : isSmall ? "small" : "large"}
            startIcon={<PhoneInTalk fontSize="large" color="primary" />}
            onClick={handleBookCall}
            sx={{
              textTransform: "none",
              color: "primary.contrastText",
              gap: 1,
              marginTop: 2,
            }}
          >
            Book a Call With
            <Typography color="primary">Sven Badalyan</Typography>
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
